var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.col.type !== 'row-title' &&
    _vm.selectedPersonas.length === 0 &&
    _vm.arraysHasCommon(_vm.row.options, ['persona'])
  )?_c('div',[_c('div',{staticClass:"add-persona",on:{"click":function($event){return _vm.setPersonaDialog(true)}}},[_c('div',{staticClass:"wrapper"},[_c('span',[_vm._v("Dodaj personę")]),_c('PlusCircleIcon')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }